module.exports = __webpack_public_path__ + "img/secure_email.967839b3.svg";